import { Fragment, useState, useEffect } from "react";

import { useLocation, useRouteMatch } from "react-router-dom";
import Alert from "../../../../../../NewComponents/TypedComponents/Alert/Alert.component";
import { appInsights } from "../../../../../../config/appInsights";
import ToggleTab from "../../../../../../NewComponents/ToggleTab/ToggleTab.component";
import { useBusinessCustomerDetail } from "../../../../../../custom-hooks/useBusinessCustomerDetails";
import { Loader } from "../../../../../../UI/Loaders/Loaders";
import { BusinessTypes } from "../../../../Interfaces";
import UserApprovals from "./Tabs/UserApprovals";
import UserSignatorySetupApproval from "./Tabs/SignatorySetupApprovals";

const Approvals = () => {
  const [activeTab, setActiveTab] = useState("user");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const match = useRouteMatch();

  const { id } = match.params as { id: number };

  const { state } = useLocation();

  useEffect(() => {
    appInsights.trackPageView({
      name: "Approval/index.tsx",
      isLoggedIn: true,
    });
  }, []);

  return (
    <Fragment>
      {error && <Alert message={error} />}
      {success && <Alert message={success} type="success" />}
      <div className="alignToggleTabItems mb-3 mt-5">
        <ToggleTab
          text="Users"
          id="user"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <ToggleTab
          text="Signatory Setup"
          id="signatory-setup"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>

      <div className="pl-5 pr-5">
        {(() => {
          switch (activeTab) {
            case "user":
              return <UserApprovals />;

            case "signatory-setup":
              return <UserSignatorySetupApproval />;

            default:
              return null;
          }
        })()}
      </div>
    </Fragment>
  );
};

export default Approvals;
